<template>
    <b-modal
        v-model="isVisible"
        size="xl"
        modal-class="vue-need-bootstrap"
        :title="modalTitle"
        lazy
        centered
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        @close="onClose"
    >
        <generic-pod-assigner
            v-if="isManualAssignment"
            :template-product-id="templateProductId"
            :pod-provider="podProvider"
            @cancel="closeModal"
            @saved="onAssignment"
        />

        <template-product-pod-assigner v-else :template-product-id="templateProductId" @save="onAssignment" />
    </b-modal>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { BModal } from 'bootstrap-vue';
import TemplateProductPodAssigner from '../TemplateProductPodAssigner/TemplateProductPodAssigner.vue';
import GenericPodAssigner from '../TemplateProductPodAssigner/GenericPodAssigner/GenericPodAssigner.vue';
import { PodAssignment, TemplateProduct } from '@/api/typings/templateProducts';
import { Provider } from '../../utils/PodProvider.enum';

const emit = defineEmits<{
    (event: 'input', value: boolean): void;
    (event: 'save', value: Record<string, unknown>): void;
    (event: 'close'): void;
}>();

const props = withDefaults(
    defineProps<{
        templateProductId?: string;
        podProvider?: string;
        podName?: string;
        value?: boolean;
    }>(),
    {
        templateProductId: '',
        podName: '',
        podProvider: ''
    }
);

// Fix: Initialize isVisible based on the value prop
const isVisible = ref(props.value || false);

// Fix: Watch the value prop to update isVisible
watch(() => props.value, (newValue) => {
    isVisible.value = newValue || false;
});

watch(isVisible, () => {
    emit('input', isVisible.value);
});

const isManualAssignment = computed(() => {
    return (
        props.podProvider?.length &&
        ![Provider.PRINTIFY, Provider.PRINTFUL].includes(props.podProvider.toLowerCase() as Provider)
    );
});

const modalTitle = computed(() => {
    const baseStr = 'Products Assigner';
    return isManualAssignment ? `${props.podName} ${baseStr}` : `POD ${baseStr}`;
});

const closeModal = () => {
    isVisible.value = false;
};

const onClose = () => {
    emit('close');
};

const onAssignment = (data: { templateProduct: TemplateProduct | null; podAssignment: PodAssignment[] }) => {
    emit('save', data);
};
</script>
